import { get, post } from './IApi';
import { DeliveryMethods } from './Data';
import $ from 'jquery';

Object.compare = function (obj1, obj2) {
  if (obj1 !== Object(obj1) || obj2 !== Object(obj2)) {
    return obj1 === obj2;
  }
  for (let p in obj1) {
    if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

    switch (typeof obj1[ p ]) {
      case 'object':
        if (!Object.compare(obj1[ p ], obj2[ p ])) return false;
        break;
      case 'function':
        if (
          typeof obj2[ p ] === 'undefined' ||
          (p !== 'compare' && obj1[ p ].toString() !== obj2[ p ].toString())
        )
          return false;
        break;
      default:
        if (obj1[ p ] !== obj2[ p ]) return false;
    }
  }

  for (let p in obj2) {
    if (typeof obj1[ p ] === 'undefined') return false;
  }
  return true;
};

export function convertDataToFormData(data) {
  const formData = new FormData();
  for (let propertyName in data) {
    if (!data.hasOwnProperty(propertyName) || !data[ propertyName ]) continue;
    if (data[ propertyName ] instanceof Date)
      formData.append(propertyName, data[ propertyName ].toISOString());
    else if (data[ propertyName ] instanceof Array) {
      data[ propertyName ].forEach((element, index) => {
        const tempFormKey = `${propertyName}[${index}]`;
        convertDataToFormData(element, formData, tempFormKey);
      });
    } else if (
      typeof data[ propertyName ] === 'object' &&
      !(data[ propertyName ] instanceof File)
    )
      convertDataToFormData(data[ propertyName ], formData, propertyName);
    else formData.append(propertyName, data[ propertyName ].toString());
  }
  return formData;
}
export function clone(o) {
  return JSON.parse(JSON.stringify(o));
}
/**
 * Parses the querystring of the given URL to a name/value dictionary object
 * @param {*} url
 */
export function parseQuerystring(url) {
  const dict = {},
    vars = url.replace(/^[^?]*\?/, '').split('&');
  for (var i = 0; i < vars.length; i++) {
    const pair = vars[ i ].split('=');
    dict[ pair[ 0 ] ] = pair[ 1 ];
  }
  return dict;
}
/**
 * Validates an email address
 * @param {*} address
 * @param {*} quiet
 */
export async function isValidEmailAddress(address) {
  if (address.match(/^.+@[^.].*\.[a-z]{2,}$/i)) {
    return true;
  }
  const response = await get(
    `generalUtils/isValidEmail/${encodeURIComponent(address)}`
  );
  if (response && response.Succeeded) {
    return response.IsValid;
  }
}

export function emailValidation(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function redeemCodeValidation(rc) {
  var re = /^[0-9a-zA-Z]+$/;
  return rc.match(re);
}

/**
 * Scroll to the given element selector (or jquery selector)
 * @param {string} element
 * @param {boolean} animate scroll smoothly. To  scroll instantaneously, this argument needs to === false
 * @param {*} deductPixels Can be either a number of pixels from the top of the element or "start", "center", "end", or "nearest".
 */
export function scrollToElement(element, animate, deductPixels) {
  //If we are in an iframe, we run this on the parent
  if (
    window.parent &&
    window.parent !== window &&
    window.parent.document.scrollToElement
  ) {
    window.parent.document.scrollToElement(element, animate, deductPixels);
    return;
  }

  const obj = $(element);
  if (animate) {
    $('html,body').animate(
      { scrollTop: obj.offset().top - (deductPixels || 0) },
      'slow'
    );
  } else {
    if (obj.length) {
      obj[ 0 ].scrollIntoView(true, {
        behavior: animate !== false ? 'smooth' : 'instant',
        block: 'end',
      });
    }
  }
}

/**
 * Gets the name of the time zone for the given date or today.
 * Can be Eastern Standard Time or Daylight savings Time
 * @param {*} sendDate
 */
export async function getTimeZoneName(sendDate) {
  const response = await post(sendDate, 'generalUtils/timeZoneName');
  if (response && response.Succeeded) {
    return response.TimeZoneName;
  }
}

export function getDeliveryMethodName(deliveryMethod, short) {
  switch (deliveryMethod) {
    case DeliveryMethods.Text:
      return `Text${short ? '' : ' Message'}`;
    case DeliveryMethods.Social:
      return `Share${short ? '' : ' via messaging'}`;
    default:
      return 'Email';
  }
}

export function needsShippingInfo(shoppingCartItem) {
  return (
    shoppingCartItem &&
    (shoppingCartItem.Type === 'Custom Physical Cards' ||
      shoppingCartItem.Type === 'Physical Cards')
  );
}

/**
 * Retrieves a list of recipients from the given csv file.
 * @param {File} file The file to parse.
 * @param {[{ firstName: string, lastName: string, email: string, phone: string }]} currentRecipients The current list of recipients.
 * @param {DeliveryMethods} deliveryMethod The deliveryMethod currently selected
 * @returns {[{ firstName: string, lastName: string, email: string, phone: string }]} The list of recipients retrieved from the given file.
 */
export function readRecipCsvFile(file, currentRecipients, deliveryMethod) {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(
        new DOMException(
          'There was a problem parsing the file. Please check the file and upload again.'
        )
      );
    };
    reader.onload = event => {
      const csv = event.target.result,
        recipients = currentRecipients;
      let lastRecip = recipients.find(r => !r.firstName),
        addedOne = false;
      if (csv) {
        const lines = csv.split('\n');
        for (let i = 0; i < lines.length; i++) {
          const line = lines[ i ].trim(),
            parsed = csvToArray(line);
          if (parsed && parsed.length) {
            const [ firstName, lastName ] = parsed;
            if (firstName === 'First_Name') continue;
            let email = '',
              phone = '';
            if (deliveryMethod === DeliveryMethods.Email) {
              [ , , email ] = parsed;
              if (!email) continue;
            } else if (deliveryMethod === DeliveryMethods.Text) {
              [ , , phone ] = parsed;
              if (!phone) continue;
            }
            if (lastRecip) {
              lastRecip.firstName = firstName;
              lastRecip.lastName = lastName;
              lastRecip.email = email;
              lastRecip.phone = phone;
              lastRecip = recipients.find(r => !r.firstName);
            } else {
              recipients.push({ firstName, lastName, email, phone });
              addedOne = true;
            }
          }
        }
      }
      addedOne
        ? resolve(recipients)
        : reject(
          new DOMException(
            'No recipients were found in the file. Please check the file and upload again.'
          )
        );
    };
    reader.readAsText(file);
  });
}

/**
 * Return array of string values, or NULL if CSV string not well formed.
 * @param {*} text Text to parse
 * @returns {[]} Returns array of values for this csv line
 */
function csvToArray(text) {
  const re_valid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/,
    re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g,
    a = [];
  //Return NULL if input string is not well formed CSV string.
  if (!re_valid.test(text)) return null;
  text.replace(
    re_value,
    //"Walk" the string using replace with callback.
    (m0, m1, m2, m3) => {
      //Remove backslash from \' in single quoted values.
      if (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
      //Remove backslash from \" in double quoted values.
      else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
      else if (m3 !== undefined) a.push(m3);
      //Return empty string.
      return '';
    }
  );
  //Handle special case of empty last value.
  if (/,\s*$/.test(text)) a.push('');
  return a;
}

export function getHtmlInnerText(htmlString) {
  return $(htmlString).text();
}

export function getCustomHtml(card, text) {
  let customHtml = null;
  if (card.CustomHtml && text) {
    const html = card.CustomHtml;
    customHtml = html.replace(getHtmlInnerText(html), text);
  }
  return customHtml;
}

export function loadScript(url) {
  return new Promise((resolve, reject) => {
    $.getScript(url)
      .done(script => resolve(script))
      .fail((jqxhr, settings, exception) =>
        reject(new DOMException(`Problem loading ${url}. ${exception.message}`))
      );
  });
}

export function validateRetailerCard(retailer, cardNumber, pin, balance) {
  return (
    retailer &&
    validateNumberAndPin(retailer, cardNumber, pin) &&
    validateBalance(retailer, balance)
  );
}

export function validateNumberAndPin(retailer, cardNumber, pin) {
  return (
    (cardNumber && !retailer.Validation.length) ||
    retailer.Validation.find(
      val =>
        (!val.CardNumberLength || val.CardNumberLength === cardNumber.length) &&
        (!val.PinLength || (pin && val.PinLength === pin.length))
    )
  );
}

export function validateBalance(retailer, balance) {
  return (
    balance &&
    (!retailer.Minimum || balance >= retailer.Minimum) &&
    (!retailer.Maximum || balance <= retailer.Maximum)
  );
}

/**
 * Parses a 'coded URL' for redirection after user is logged in.
 * @param {*} codedUrl
 */
export async function parseLoginURL(codedUrl) {
  const response = await get(`generalUtils/parseCodedUrl/${codedUrl}`);
  if (response && response.Succeeded) {
    return response.Url;
  }
}

/**
 * Register the current page in AnalyticsPageView
 * @param {{page_title:string, page_location:string, page_path: string}} options
 */
export function registerAnalyticsPageView(options) {
  window.gtag('config', 'UA-2926663-1', options);
}

/**
 * Download the given text as a file with the given name.
 * @param {string} fileText
 * @param {string} fileName
 */
export function downloadFile(fileText, fileName) {
  const mimeType = 'text/csv;encoding:utf-8',
    a = document.createElement('a');
  if (navigator.msSaveBlob) { // IE10
    navigator.msSaveBlob(new Blob([ fileText ], {
      type: mimeType
    }), fileName);
  }
  else if (URL && 'download' in a) { //html5 A[download]
    a.href = URL.createObjectURL(new Blob([ fileText ], {
      type: mimeType
    }));
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  else {
    window.location.href = 'data:application/octet-stream,' + encodeURIComponent(fileText);
  }
}
